export const FETCH_WOW_REQUEST = 'FETCH_WOW_REQUEST';
export const FETCH_ADVERTISER_DATE_QUARTER = 'FETCH_ADVERTISER_DATE_QUARTER';
export const FETCH_WOW_DATE_ERROR = 'FETCH_WOW_DATE_ERROR';
export const SET_SELECTED_WOW_QUARTERS = 'SET_SELECTED_WOW_QUARTERS';
export const FETCHED_WOW_REPORT = 'FETCHED_WOW_REPORT';
export const FETCHED_WOW_REPORT_ERROR = 'FETCHED_WOW_REPORT_ERROR';
export const RESET_WOW_DATA = 'RESET_WOW_DATA';
export const SET_WOW_START_DATE = 'SET_WOW_START_DATE';
export const SET_WOW_END_DATE = 'SET_WOW_END_DATE';
export const SET_WOW_QUARTER_RANGES = 'SET_WOW_QUARTER_RANGES';
export const CLEAR_WOW_LOADING = 'CLEAR_WOW_LOADING';
